import { render, staticRenderFns } from "./ImageSelectBase64.vue?vue&type=template&id=b156b698&scoped=true&"
import script from "./ImageSelectBase64.vue?vue&type=script&lang=ts&"
export * from "./ImageSelectBase64.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b156b698",
  null
  
)

export default component.exports